import {
  AlertErrorSolidIcon,
  AlertInfoSolidIcon,
  AlertSuccessSolidIcon,
  AlertWarningSolidIcon,
} from '@pmi/dsm-react/dist/components/icons';

function CustomAlertInfoIcon() {
  return <AlertInfoSolidIcon color="info" fontSize="sm" />;
}
function CustomAlertErrorIcon() {
  return <AlertErrorSolidIcon color="danger" fontSize="sm" />;
}

function CustomAlertWarningIcon() {
  return <AlertWarningSolidIcon color="warning" fontSize="sm" />;
}

function CustomAlertSuccessIcon() {
  return <AlertSuccessSolidIcon color="success" fontSize="sm" />;
}

function CustomAlertNeutralIcon() {
  return <AlertInfoSolidIcon color="neutral" fontSize="sm" />;
}

// eslint-disable-next-line import/prefer-default-export
export const IconMap = {
  info: CustomAlertInfoIcon,
  danger: CustomAlertErrorIcon,
  warning: CustomAlertWarningIcon,
  success: CustomAlertSuccessIcon,
  neutral: CustomAlertNeutralIcon,
};
